<template>
    <footer
        aria-labelledby="footer-heading"
        class="bg-primary">
        <h2
            id="footer-heading"
            class="sr-only">
            Footer
        </h2>
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div class="pt-20 grid grid-cols-2 md:grid-cols-3 gap-8">
                <div class="col-span-2 md:col-span-1">
                    <img
                        src="/2026_EK-Liga_quer_w.png"
                        class="h-16"
                        alt="Eichenkreuzliga Logo">
                </div>
                <div>
                    <h3 class="text-4xl uppercase font-medium text-white font-family-squada-one">
                        Service
                    </h3>
                    <ul
                        role="list"
                        class="mt-4 space-y-2">
                        <li
                            v-for="item in footerNavigation.service"
                            :key="item.name">
                            <NuxtLink
                                :to="item.href"
                                class="text-white hover:text-primary-red">
                                {{ item.name }}
                            </NuxtLink>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 class="text-4xl uppercase font-medium text-white font-family-squada-one">
                        Infos
                    </h3>
                    <ul
                        role="list"
                        class="mt-4 space-y-2">
                        <li
                            v-for="item in footerNavigation.info"
                            :key="item.name">
                            <NuxtLink
                                :to="item.href"
                                class="text-white hover:text-primary-red">
                                {{ item.name }}
                            </NuxtLink>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="py-10">
                <p class="text-white">
                    Die Eichenkreuzliga ist ein Angebot der Evangelischen Sportbewegung Württemberg – www.evangelische-sportbewegung.de<br>
                    &copy; {{ dayjs().year() }} Evangelisches Jugendwerk Württemberg
                </p>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
const dayjs = useDayjs()

const footerNavigation = {
    service: [
        {name: 'Infos EichenkreuzLiga', href: '/infos/infos-eichenkreuzliga'},
        {name: 'Downloads', href: '/infos/downloads'},
        {name: 'Kontakt', href: '/infos/kontakt'},
        {name: 'Newsletter', href: '/infos/newsletter'},
    ],
    info: [
        {name: 'Impressum', href: '/infos/impressum'},
        {name: 'Datenschutz', href: '/infos/datenschutz'},
    ],
}

</script>